// extracted by mini-css-extract-plugin
export default {"Content":"Layout_Content__Qn5Ke","Layout":"Layout_Layout__BywIp"};